/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import { Button, ButtonProps, styled, SxProps } from "@mui/material";
import { Theme } from "@mui/material/styles";
import Colors from "util/colors";

const StyledButton = styled(Button)({
  fontWeight: 600,
});

StyledButton.defaultProps = {
  // variant: "primary",
  // color: "primary",
};

/**
 * プロパティ定義
 */
type Props = ButtonProps & {
  /** ボタンログID */
  id: string;
  sx?: SxProps<Theme>;
};

/**
 * アプリ共通のボタン
 * @param props コンポーネントのProps
 */
export default function AppButton(props: Props) {
  const sx = props.sx ?? {};

  // ボタン押下
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (props.onClick) props.onClick(e);
  };

  return (
    <StyledButton {...props} sx={sx} onClick={handleClick}>
      {props.children}
    </StyledButton>
  );
}
